import React from "react";
import AppointmentItem from "./appointment";
import arrow from "../../assets/images/arrows_left_icon.png"

const SuggestedAppointment = ({ onClick, next, project }) => {
  return (
    <div className="suggest-appointment" onClick={onClick}>
      <div className="suggest-appointment-top">
        <div>Inhouse-Schulung für deine Apotheke anfragen</div>
      </div>
      <AppointmentItem 
        arrow={arrow}
        next={next}
        project={project}
      />
    </div>
  );
  };
  
  export default SuggestedAppointment;
  